var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.shouldAuth)?_c('div',{staticClass:"fixed w-full inset-0 z-10 overflow-hidden flex justify-center items-center"},[_c('div',{staticClass:"fixed w-full inset-0 z-20 bg-gray-700 opacity-75",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_c('login-form-component')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }